module.exports = __webpack_public_path__ + "name=img/src/assets/story/4.jpg?63276310293eed0e753c927c8328d0bd";